import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=42e2412a&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"
import style0 from "./Logo.vue?vue&type=style&index=0&id=42e2412a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e2412a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42e2412a')) {
      api.createRecord('42e2412a', component.options)
    } else {
      api.reload('42e2412a', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=42e2412a&scoped=true", function () {
      api.rerender('42e2412a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainContent/Logo.vue"
export default component.exports